import { api } from './api.js';
import { setUser, setUserIsLoading } from '../store/user.js';
import { HTTP_ACCEPTED } from '../utils/constants.js';

export const authEndpoints = api.enhanceEndpoints({ addTagTypes: ['auth'] }).injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: '/login',
                method: 'POST',
                body: data
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;

                localStorage.setItem('accessToken', data.response.accessToken);

                dispatch(setUser(data.response.user));
                if (data.response.mfaIdentifier) {
                    sessionStorage.setItem('mfaIdentifier', data.response.mfaIdentifier);
                }
                dispatch(setUserIsLoading(false));

                if (data.status === HTTP_ACCEPTED) {
                    localStorage.removeItem('mfaIdentifier');
                }
            }
        }),
        twoFactor: builder.mutation({
            query: (requestData) => ({
                url: '/two-factor',
                method: 'POST',
                body: requestData
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        resendTwoFactor: builder.mutation({
            query: (requestData) => ({
                url: '/resend-two-factor',
                method: 'POST',
                body: requestData
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        forgotPassword: builder.mutation({
            query: (requestData) => ({
                url: '/forgot-password',
                method: 'POST',
                body: requestData
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        changePassword: builder.mutation({
            query: (requestData) => ({
                url: '/change-password',
                method: 'POST',
                body: requestData
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        register: builder.mutation({
            query: (requestData) => ({
                url: '/register',
                method: 'POST',
                body: requestData
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                localStorage.setItem('accessToken', data.response.accessToken);
                dispatch(setUser(data.response.user));
                dispatch(setUserIsLoading(false));
            }
        }),
        verifyEmail: builder.mutation({
            query: (requestData) => ({
                url: '/verify-email',
                method: 'POST',
                body: requestData
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(setUser(data.response.user));
                localStorage.setItem('mfaIdentifier', data.response.mfaIdentifier);
                dispatch(setUserIsLoading(false));
            }
        }),
        resendVerifyEmail: builder.mutation({
            query: () => ({
                url: '/resend-verify-email',
                method: 'POST'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    })
});

export const {
    useLoginMutation,
    useTwoFactorMutation,
    useResendTwoFactorMutation,
    useVerifyEmailMutation,
    useResendVerifyEmailMutation,
    useForgotPasswordMutation,
    useChangePasswordMutation,
    useRegisterMutation
} = authEndpoints;
